import { useDispatch, useSelector } from "react-redux";


import ToastMessage from "./righttoptoast";
import { hideToast } from "../../reduxtoolkit/toastslice";

export default function GlobalToast() {
  const dispatch = useDispatch();
  const { open, message, severity } = useSelector((s) => s.toast);

  return (
    <ToastMessage
      open={open}
      message={message}
      severity={severity}
      handleClose={() => dispatch(hideToast())}
    />
  );
}
